<template>
    <div><!--
        <b-container fluid>
            <Newsletter v-if="$config.newsletters && $config.newsletters.consumer"
                :newsletter="$config.newsletters.consumer"
            />
        <br/>
        </b-container>-->
        <div class="prefooter-blocks-small">
            <b-row>
                <!--<b-col sm="12" md="6" lg="4" class="block-wrap">
                <div class="block">
                    <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path custom-fill-tertiary d="M2.24599 0.0129395C1.94101 0.0136888 1.64305 0.104116 1.38906 0.272949L10.489 8.89307C10.5732 8.98283 10.6748 9.05436 10.7877 9.10327C10.9007 9.15218 11.0225 9.17725 11.1455 9.17725C11.2686 9.17725 11.3903 9.15218 11.5032 9.10327C11.6161 9.05436 11.7178 8.98283 11.802 8.89307L20.885 0.272949C20.6303 0.104117 20.3316 0.0137089 20.026 0.0129395H2.24599ZM0.733053 1.12402C0.66804 1.30466 0.634248 1.49503 0.633078 1.68701V12.887C0.631467 13.2115 0.721958 13.5298 0.894064 13.8049L7.32607 7.38208L0.733053 1.12402ZM21.542 1.12402L14.9671 7.37012L21.381 13.802C21.5531 13.5269 21.6436 13.2086 21.642 12.884V1.68408C21.6409 1.4921 21.6071 1.30172 21.542 1.12109V1.12402ZM14.1851 8.11597L12.542 9.67407C12.1645 10.0311 11.6647 10.23 11.145 10.23C10.6254 10.23 10.1256 10.0311 9.74807 9.67407L8.10708 8.125L1.74306 14.4709C1.90385 14.5269 2.07283 14.5556 2.24306 14.5559H20.023C20.1949 14.5559 20.3655 14.5272 20.528 14.4709L14.1851 8.11597Z" fill="#333333"/>
                    </svg>              
                    <p class="footer-dynamic-text" custom-color-tertiary>Hai bisogno di aiuto?</p>
                </div>
                </b-col>-->

                <!--<b-col sm="12" md="6" lg="4" class="block-wrap">
                <router-link :to="{name: 'faq'}">
                <div class="block">
                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path custom-fill-tertiary d="M21.643 7.2439V14.095C21.6398 14.6143 21.4598 15.1171 21.1326 15.5205C20.8054 15.9239 20.3505 16.2037 19.843 16.314V18.3359C19.8427 18.5609 19.7533 18.7767 19.5944 18.9358C19.4354 19.0949 19.2199 19.1845 18.995 19.1851C18.7696 19.1809 18.5532 19.0961 18.385 18.946L15.819 16.3779H8.05399C7.47636 16.3782 6.92046 16.1579 6.49985 15.762C6.07923 15.3661 5.82565 14.8246 5.79099 14.248L7.09698 12.9419H7.35699V14.1169C7.35699 14.3026 7.43074 14.4808 7.56201 14.6121C7.69329 14.7433 7.87136 14.8169 8.05701 14.8169H16.474L18.258 16.6001V14.8169H19.389C19.5747 14.8169 19.7527 14.7433 19.884 14.6121C20.0152 14.4808 20.089 14.3026 20.089 14.1169V7.2439C20.089 7.05825 20.0152 6.8803 19.884 6.74902C19.7527 6.61775 19.5747 6.54395 19.389 6.54395H18.019V4.95606H19.389C19.9892 4.96799 20.561 5.2133 20.9833 5.63989C21.4056 6.06649 21.6451 6.64073 21.651 7.24097L21.643 7.2439ZM0.639008 9.15503V2.30005C0.638876 2.00296 0.697283 1.70882 0.810913 1.43433C0.924543 1.15983 1.09117 0.910268 1.30124 0.700196C1.51131 0.490124 1.76072 0.323591 2.03522 0.209962C2.30972 0.0963322 2.60391 0.0379554 2.901 0.0380868H14.2C14.4971 0.0378238 14.7914 0.0961347 15.0659 0.209718C15.3405 0.323301 15.59 0.489854 15.8 0.699952C16.0101 0.910051 16.1768 1.15953 16.2903 1.43408C16.4039 1.70864 16.4623 2.00293 16.462 2.30005V9.15308C16.4621 9.45012 16.4037 9.74411 16.2901 10.0186C16.1764 10.293 16.0098 10.5424 15.7997 10.7524C15.5896 10.9624 15.3402 11.1289 15.0657 11.2424C14.7912 11.356 14.4971 11.4143 14.2 11.4141H6.457L3.89001 14.0029C3.73293 14.1561 3.52241 14.2422 3.30301 14.2429C3.08431 14.2387 2.87504 14.1531 2.716 14.0029C2.63021 13.9223 2.5625 13.8243 2.51733 13.7156C2.47217 13.6068 2.45059 13.4898 2.45401 13.3721V11.3491C1.94063 11.2532 1.47694 10.9806 1.14328 10.5789C0.809618 10.1771 0.626999 9.67119 0.627014 9.14893L0.639008 9.15503ZM9.17499 8.32202C9.17566 8.27614 9.16712 8.23052 9.14987 8.18799C9.13262 8.14546 9.10703 8.10691 9.07458 8.07446C9.04214 8.04201 9.00349 8.01627 8.96097 7.99902C8.91844 7.98177 8.87288 7.97345 8.827 7.97412H7.914C7.86812 7.97345 7.82256 7.98177 7.78003 7.99902C7.7375 8.01627 7.69886 8.04201 7.66641 8.07446C7.63396 8.10691 7.60838 8.14546 7.59113 8.18799C7.57388 8.23052 7.56534 8.27614 7.56601 8.32202V8.90894C7.56534 8.95482 7.57388 9.00044 7.59113 9.04297C7.60838 9.0855 7.63396 9.12405 7.66641 9.1565C7.69886 9.18894 7.7375 9.21468 7.78003 9.23193C7.82256 9.24918 7.86812 9.25776 7.914 9.25708H8.827C8.87288 9.25776 8.91844 9.24918 8.96097 9.23193C9.00349 9.21468 9.04214 9.18894 9.07458 9.1565C9.10703 9.12405 9.13262 9.0855 9.14987 9.04297C9.16712 9.00044 9.17566 8.95482 9.17499 8.90894V8.32202ZM6.17499 3.92798C6.17281 3.95808 6.17679 3.98832 6.18665 4.01685C6.1965 4.04537 6.21204 4.07165 6.23233 4.094C6.25262 4.11634 6.27721 4.13442 6.30466 4.14697C6.3321 4.15953 6.36183 4.16626 6.392 4.16699L7.41501 4.18897C7.49642 4.19102 7.5763 4.16666 7.64279 4.11963C7.70928 4.0726 7.75881 4.00543 7.784 3.92798C7.824 3.80505 7.89255 3.69341 7.98401 3.60205C8.13366 3.46922 8.32796 3.39784 8.52802 3.4021C8.64074 3.3958 8.75348 3.41383 8.85858 3.45508C8.96368 3.49632 9.05864 3.55983 9.13699 3.64111C9.21535 3.72972 9.27504 3.83312 9.3125 3.94531C9.34996 4.05751 9.36442 4.17604 9.35501 4.29395C9.35688 4.54163 9.28744 4.78458 9.155 4.9939C9.02894 5.19675 8.85785 5.36784 8.655 5.4939C8.32333 5.70492 8.02929 5.97009 7.785 6.27808C7.64287 6.49831 7.56749 6.75498 7.56799 7.01709C7.56476 7.05217 7.56929 7.08747 7.58127 7.12061C7.59324 7.15374 7.61236 7.18383 7.63727 7.20874C7.66218 7.23365 7.6923 7.25268 7.72543 7.26465C7.75857 7.27662 7.79393 7.28131 7.82901 7.27808H8.93799C9.00053 7.27956 9.06148 7.25812 9.1095 7.21802C9.15751 7.17792 9.18932 7.12186 9.19901 7.06006C9.2066 6.91637 9.24371 6.7757 9.30801 6.64697C9.40273 6.46651 9.5457 6.31586 9.72101 6.21192C10.0815 6.02417 10.3942 5.75636 10.635 5.42896C10.8691 5.10726 10.9913 4.71784 10.983 4.32007C10.9953 4.02702 10.9433 3.73485 10.8304 3.46411C10.7176 3.19337 10.5468 2.9505 10.33 2.75293C9.82427 2.33948 9.18223 2.13018 8.53 2.16602C7.91789 2.13888 7.31396 2.31465 6.81201 2.66602C6.61874 2.81542 6.46163 3.00636 6.35239 3.22485C6.24314 3.44335 6.18456 3.68372 6.181 3.92798" fill="#333333"/>
                    </svg>            
                    <p class="footer-dynamic-text" custom-color-tertiary>Domande frequenti</p>
                </div>
                </router-link>
                </b-col>-->

                <b-col sm="12" md="6" lg="3" class="block-wrap">
                <div class="block">
                <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path custom-fill-tertiary d="M6.60601 9.8831V5.12211H1.45202C1.34382 5.12104 1.23644 5.14147 1.13628 5.18241C1.03612 5.22336 0.945167 5.28383 0.868703 5.36039C0.792238 5.43695 0.73185 5.52801 0.691029 5.62821C0.650209 5.72842 0.629767 5.83594 0.630971 5.94413V14.1841C0.629899 14.2922 0.650442 14.3993 0.691334 14.4993C0.732227 14.5993 0.792665 14.6903 0.86913 14.7666C0.945594 14.843 1.03656 14.9034 1.13665 14.9441C1.23673 14.9849 1.34395 15.0051 1.45202 15.0039H2.90001V17.991C2.89823 18.0716 2.92044 18.1509 2.96386 18.2188C3.00728 18.2867 3.0699 18.3402 3.14379 18.3724C3.21768 18.4045 3.29949 18.4139 3.37877 18.3995C3.45805 18.385 3.53121 18.3472 3.58898 18.2911L6.872 15.0081H14.127C14.2351 15.0093 14.3423 14.9888 14.4424 14.948C14.5425 14.9073 14.6334 14.8469 14.7098 14.7705C14.7863 14.6942 14.8468 14.6033 14.8877 14.5032C14.9286 14.4032 14.9491 14.2961 14.948 14.188V11.365H8.11901C7.72324 11.3677 7.3424 11.2139 7.05956 10.9371C6.77672 10.6602 6.61479 10.2827 6.609 9.887" fill="#333333"/>
                    <path custom-fill-tertiary d="M20.822 0.821085H8.11698C8.00887 0.820016 7.90164 0.840507 7.80155 0.881388C7.70146 0.922268 7.61049 0.982671 7.53404 1.05912C7.45759 1.13557 7.39718 1.22661 7.3563 1.3267C7.31542 1.42679 7.29493 1.53402 7.296 1.64213V9.88212C7.29493 9.99023 7.31542 10.0975 7.3563 10.1975C7.39718 10.2976 7.45759 10.3884 7.53404 10.4649C7.61049 10.5413 7.70146 10.6017 7.80155 10.6426C7.90164 10.6835 8.00887 10.704 8.11698 10.7029H15.372L18.655 13.9861C18.7115 14.0459 18.785 14.0868 18.8656 14.1033C18.9462 14.1198 19.0298 14.111 19.1053 14.0782C19.1807 14.0454 19.2442 13.9901 19.2871 13.92C19.33 13.8498 19.3502 13.7682 19.3449 13.6861V10.7H20.822C20.9301 10.7011 21.0372 10.6806 21.1372 10.6397C21.2373 10.5988 21.3281 10.5384 21.4045 10.462C21.4809 10.3855 21.5412 10.2945 21.582 10.1944C21.6228 10.0943 21.6432 9.98701 21.642 9.87895V1.63896C21.6432 1.53089 21.6228 1.42386 21.582 1.32377C21.5412 1.22368 21.4809 1.13266 21.4045 1.05619C21.3281 0.979728 21.2373 0.91935 21.1372 0.878458C21.0372 0.837566 20.9301 0.817084 20.822 0.818155V0.821085ZM10.612 6.56303C10.4171 6.56303 10.2266 6.50529 10.0646 6.39701C9.90261 6.28874 9.77641 6.13467 9.70188 5.95463C9.62736 5.77459 9.60789 5.57664 9.64597 5.38554C9.68406 5.19444 9.77796 5.01886 9.91581 4.88114C10.0537 4.74343 10.2293 4.64975 10.4204 4.61186C10.6116 4.57396 10.8096 4.59355 10.9896 4.66825C11.1696 4.74296 11.3233 4.86942 11.4314 5.03153C11.5395 5.19365 11.5972 5.38428 11.597 5.57914C11.5993 5.70908 11.5753 5.83804 11.5267 5.95854C11.478 6.07903 11.4055 6.18846 11.3136 6.28031C11.2216 6.37216 11.1121 6.44463 10.9916 6.4932C10.871 6.54178 10.7419 6.56547 10.612 6.56303ZM14.486 6.56303C14.2911 6.56303 14.1006 6.50529 13.9386 6.39701C13.7766 6.28874 13.6504 6.13467 13.5758 5.95463C13.5013 5.77459 13.4819 5.57664 13.52 5.38554C13.5581 5.19444 13.652 5.01886 13.7898 4.88114C13.9277 4.74343 14.1033 4.64975 14.2944 4.61186C14.4855 4.57396 14.6837 4.59355 14.8636 4.66825C15.0436 4.74296 15.1973 4.86942 15.3055 5.03153C15.4136 5.19365 15.4712 5.38428 15.471 5.57914C15.4699 5.83996 15.3658 6.08963 15.1813 6.27397C14.9967 6.4583 14.7468 6.56224 14.486 6.56303ZM18.327 6.56303C18.1321 6.56303 17.9416 6.50529 17.7796 6.39701C17.6176 6.28874 17.4914 6.13467 17.4168 5.95463C17.3423 5.77459 17.3229 5.57664 17.361 5.38554C17.3991 5.19444 17.493 5.01886 17.6308 4.88114C17.7687 4.74343 17.9443 4.64975 18.1354 4.61186C18.3266 4.57396 18.5247 4.59355 18.7046 4.66825C18.8846 4.74296 19.0384 4.86942 19.1465 5.03153C19.2546 5.19365 19.3122 5.38428 19.312 5.57914C19.3143 5.70908 19.2904 5.83804 19.2417 5.95854C19.193 6.07903 19.1205 6.18846 19.0285 6.28031C18.9366 6.37216 18.8271 6.44463 18.7066 6.4932C18.586 6.54178 18.4569 6.56547 18.327 6.56303Z" fill="#333333"/>
                </svg>        
                    <p>
                        <a class="footer-dynamic-text" custom-color-tertiary v-bind:href="'javascript:window.zE.activate()'">Online chat</a>
                        <br>
                        <small class="footer-dynamic-text" custom-color-tertiary>lun-ven 09:00 - 19:00</small>
                    </p>
                </div>
                </b-col>

                <b-col sm="12" md="6" lg="3" class="block-wrap">
                <div class="block">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path custom-fill-tertiary fill-rule="evenodd" clip-rule="evenodd" d="M11.327 0.121094C9.49999 0.121655 7.70583 0.607326 6.12805 1.52856C4.55028 2.4498 3.24548 3.77342 2.34698 5.36426C1.44848 6.95509 0.9885 8.75615 1.01416 10.583C1.03982 12.4099 1.55015 14.197 2.49298 15.762L0.630981 21.2971L6.34198 19.468C7.71997 20.2288 9.2538 20.6641 10.826 20.7407C12.3982 20.8173 13.967 20.5331 15.4125 19.9099C16.8579 19.2867 18.1415 18.3411 19.1651 17.1453C20.1887 15.9495 20.9251 14.5353 21.3178 13.011C21.7106 11.4867 21.7493 9.89287 21.431 8.35132C21.1128 6.80977 20.446 5.3613 19.4817 4.11719C18.5174 2.87308 17.2812 1.86626 15.8677 1.17358C14.4543 0.480904 12.9011 0.120931 11.327 0.121094ZM11.327 19.021C9.64694 19.0228 8.00368 18.5289 6.60303 17.6011L3.30298 18.658L4.375 15.468C3.24529 13.9062 2.6741 12.0096 2.75342 10.0837C2.83274 8.15784 3.55794 6.31467 4.81226 4.85107C6.06657 3.38748 7.77697 2.38861 9.66803 2.01538C11.5591 1.64215 13.5207 1.91641 15.2371 2.7937C16.9534 3.671 18.3245 5.10045 19.1296 6.85181C19.9347 8.60316 20.1268 10.5744 19.6752 12.4482C19.2235 14.3221 18.1544 15.9896 16.6398 17.1819C15.1253 18.3742 13.2535 19.0219 11.326 19.021H11.327ZM16.163 12.7781C15.904 12.6361 14.635 11.951 14.396 11.854C14.157 11.757 13.984 11.7071 13.796 11.9651C13.608 12.2231 13.083 12.7951 12.924 12.9651C12.765 13.1351 12.608 13.1501 12.349 13.0081C11.5846 12.6697 10.8849 12.201 10.281 11.623C9.72584 11.0694 9.25572 10.4366 8.88599 9.74512C8.74099 9.47512 8.886 9.33789 9.021 9.21289C9.156 9.08789 9.29598 8.91289 9.43298 8.76489C9.54637 8.63603 9.64069 8.4916 9.71301 8.33594C9.75067 8.26477 9.76992 8.18549 9.76904 8.10498C9.76817 8.02447 9.7472 7.94533 9.70801 7.875C9.64701 7.74 9.16897 6.42392 8.96997 5.88892C8.77097 5.35392 8.54801 5.433 8.39301 5.427C8.23801 5.421 8.06501 5.39296 7.89301 5.38696C7.75992 5.38526 7.62793 5.41103 7.50525 5.46265C7.38257 5.51426 7.27183 5.59068 7.17999 5.68701C6.87267 5.95827 6.62509 6.29035 6.45294 6.66235C6.2808 7.03436 6.18785 7.43807 6.17999 7.8479C6.22806 8.8442 6.56586 9.80497 7.15198 10.6121C8.18073 12.3765 9.68872 13.8129 11.501 14.7549C14.139 15.9099 14.152 15.555 14.637 15.532C15.0073 15.4738 15.3611 15.3382 15.6754 15.134C15.9897 14.9298 16.2574 14.6616 16.461 14.3469C16.6479 13.96 16.7175 13.527 16.661 13.1011C16.6 12.9891 16.427 12.9169 16.168 12.7749" fill="#333333"/>
                    </svg>
                    <p>
                        <a class="footer-dynamic-text" custom-color-tertiary v-bind:href="config.site.waIntentLink" target="_blank">
                            Whatsapp:<br>{{config.site.mobileNumber}}
                        </a>
                        <br>
                        <small class="footer-dynamic-text" custom-color-tertiary>lun-ven 09:00 - 19:00</small></p>
                </div>
                </b-col>

                <b-col sm="12" md="6" lg="3" class="block-wrap">
                <div class="block">
                    <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path custom-fill-tertiary d="M2.24599 0.0129395C1.94101 0.0136888 1.64305 0.104116 1.38906 0.272949L10.489 8.89307C10.5732 8.98283 10.6748 9.05436 10.7877 9.10327C10.9007 9.15218 11.0225 9.17725 11.1455 9.17725C11.2686 9.17725 11.3903 9.15218 11.5032 9.10327C11.6161 9.05436 11.7178 8.98283 11.802 8.89307L20.885 0.272949C20.6303 0.104117 20.3316 0.0137089 20.026 0.0129395H2.24599ZM0.733053 1.12402C0.66804 1.30466 0.634248 1.49503 0.633078 1.68701V12.887C0.631467 13.2115 0.721958 13.5298 0.894064 13.8049L7.32607 7.38208L0.733053 1.12402ZM21.542 1.12402L14.9671 7.37012L21.381 13.802C21.5531 13.5269 21.6436 13.2086 21.642 12.884V1.68408C21.6409 1.4921 21.6071 1.30172 21.542 1.12109V1.12402ZM14.1851 8.11597L12.542 9.67407C12.1645 10.0311 11.6647 10.23 11.145 10.23C10.6254 10.23 10.1256 10.0311 9.74807 9.67407L8.10708 8.125L1.74306 14.4709C1.90385 14.5269 2.07283 14.5556 2.24306 14.5559H20.023C20.1949 14.5559 20.3655 14.5272 20.528 14.4709L14.1851 8.11597Z" fill="#333333"/>
                    </svg>
                    <p>
                        <a class="footer-dynamic-text" custom-color-tertiary v-bind:href="'mailto:' + config.site.emailSupport">{{config.site.emailSupport}}</a>
                        <small class="footer-dynamic-text" custom-color-tertiary>lun-ven 9:00 - 19:00</small></p>
                </div>
                </b-col>

                <b-col sm="12" md="6" lg="3" class="block-wrap">
                <div class="block">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path custom-fill-tertiary d="M21.1999 15.855L18.1789 12.834C17.8957 12.5527 17.5127 12.3948 17.1135 12.3948C16.7143 12.3948 16.3312 12.5527 16.048 12.834L14.675 14.207C11.5218 12.7128 8.98276 10.1735 7.489 7.02002L8.86095 5.64697C9.1435 5.36436 9.30223 4.98117 9.30223 4.58154C9.30223 4.18192 9.1435 3.79872 8.86095 3.51611L5.84203 0.496094C5.55912 0.213727 5.1757 0.0549316 4.77599 0.0549316C4.37628 0.0549316 3.99285 0.213727 3.70995 0.496094L1.52794 2.67603L1.43395 2.77588C-0.327055 4.68788 0.555967 9.23799 6.50597 15.188C9.77897 18.461 13.7389 21.105 16.6059 21.105C17.4606 21.1357 18.2935 20.8315 18.927 20.2571L21.2049 17.9839C21.4863 17.7006 21.6441 17.3177 21.6441 16.9185C21.6441 16.5192 21.4863 16.1363 21.2049 15.853" fill="#333333"/>
                </svg>
                    <p>
                        <a class="footer-dynamic-text" custom-color-tertiary v-bind:href="'phone:' + config.site.phoneNumber">{{config.site.phoneNumber}}</a>
                        <small class="footer-dynamic-text" custom-color-tertiary>lun-ven 09:00 - 19:00</small>
                    </p>
                </div>
                </b-col>

            </b-row>
        </div>    
    </div>
</template>

<script>

//import Newsletter from '@/components/blocks/common/newsletter'
//import Phone from '../../svg/phone'
//import Mail from '../../svg/mail'
//import Whatsapp from '../../svg/whatsapp'
//import Chat from '../../svg/chat'
//import Question from '../../svg/question'
//import Help from '../../svg/help'
export default {
    name: 'prefooter',
    components:
    {
        //Newsletter,
        //Phone, Mail, Whatsapp, Chat, Question, Help
    },
    data()
    {
        return {
            config: this.$config
        }
    }
}
</script>

<style lang="scss">
    .prefooter-blocks-small
    {
        //@include customize-background-color(tertiary);
        background:$tertiary;
        font-weight:400;
        border-radius: $border-radius;
        $block-pad: $grid-gutter-width/2;
        margin-bottom:2rem;
        margin-top: 4rem !important;
        
        .block
        {
            display:flex;
            align-items: center;
            font-size:15px;
            min-height:6rem;
            padding:$block-pad $block-pad 0 $block-pad;
            position:relative;
            svg
            {
                margin-right:1rem;
                margin-top:0.15rem;
                min-width:22px;
            }
            p
            {
                margin-bottom:0;
            }
            small
            {
                display:block;
            }
            a,a:hover
            {
                text-decoration:none;
            }
            //@include customize-color("tertiary");

            *
            {
                color:$white;
                fill:$white;
            }

            .footer-dynamic-text
            {
            }

            svg
            {
            }
            .footer-dynamic-text
            {
                //@include customize-color("tertiary");
                //@include dynamic-colors-filters();
            }
        }
        .heading-block
        {
        svg
        {
            width:48px;
        }
        font-size:22px;
        line-height: 100%;
        font-weight:600;
        p
        {
            padding:4px 0;
        }
        }
        .block-wrap:last-child .block
        {
        padding-bottom:$block-pad;
        }

        @include media-breakpoint-only(md)
        {
        .block
        {
            width:320px;
            margin:auto;
        }
        .heading-block
        {
            width:420px;
            text-align: center;
            justify-content: center;
            svg
            {
            display:none;
            }
        }
        }

        @include media-breakpoint-only(lg)
        {
            flex-wrap:wrap;
            $block-pad: $grid-gutter-width/4;
            padding-bottom:1rem;
            padding-top:1rem;
            .row
            {
                justify-content: center;
            }
            .block
            {
                min-height:0;
                display:flex;
                justify-content: center;
                align-content:center;
                height:100%;
                svg
                {
                margin-right:1rem;
                margin-top:0.15rem;
                }
            }
            .block-wrap:last-child .block
            {
                padding-bottom:$block-pad;
            }
            .block:after
            {
                display:none;
            }

            .block
            {
                padding:12px 12px 0 12px;
            }
            .block:not(.heading-block) *
            {
                font-size: 12px;
            }
        }

        @include media-breakpoint-up(xl)
        {
            $block-pad: $grid-gutter-width/3 $grid-gutter-width/4;
            .block
            {
                min-height:0;
                //border:1px solid red;
                display:flex;
                justify-content: center;
                align-content:center;
                height:100%;
                padding:$block-pad;
                svg
                {
                margin-right:1rem;
                margin-top:0.15rem;
                }
            }
            .block-wrap:last-child .block
            {
                padding-bottom:$block-pad;
            }
            .block-wrap:not(:last-child) .block
            {
                padding-bottom:$block-pad;
            }
        }

        @include media-breakpoint-up(xxl)
        {
            .block-wrap:not(:first-child)
            {
                padding-left:0;
            }
            .block-wrap:not(:last-child)
            {
                padding-right:0;
            }
            .block-wrap:not(:last-child) .block
            {
                padding-bottom:$block-pad;
            }
        }

    }
    
</style>